// Ported from design/project/App75-WithdrawPaused.dc.html, then wired to the 24 hour hold after a wallet switch.
import { useEffect, useState } from "react";
import { holdUntil, serverNow, shortAddress, SUPPORT_URL, useMoney, walletName } from "../money.js";
import { go } from "../router.js";
import { Line, SheetBackdrop, SheetTitle } from "./money-parts.js";

const two = (n: number) => String(n).padStart(2, "0");
const clock = (ms: number) => {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${two(Math.floor(s / 3600))}:${two(Math.floor((s % 3600) / 60))}:${two(s % 60)}`;
};
const timeOf = (ms: number) => new Date(ms).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });

export function App75_WithdrawPaused() {
  const { view } = useMoney();
  const [, tick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 1000);
    return () => clearInterval(t);
  }, []);
  const until = holdUntil(view);
  useEffect(() => {
    if (view && !until) go("App40", true);
  }, [view, until]);
  if (!view?.wallet || !until) return null;

  const left = until - serverNow(view);
  const changed = view.wallet.connectedAt;
  const sameDay = new Date(changed).toDateString() === new Date().toDateString();
  const opensToday = new Date(until).toDateString() === new Date().toDateString();

  return (
    <>
      <div className="screen">
  <SheetBackdrop />
  <div className="sheet g squeeze" style={{ background: "rgba(18,22,29,0.96)", borderBottom: "0" }}>
    <SheetTitle>Withdraw</SheetTitle>

    <div style={{ marginTop: "16px", padding: "18px", borderRadius: "20px", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", display: "flex", flexDirection: "column", alignItems: "center", gap: "6px", textAlign: "center" }}>
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#CCFF00" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><circle cx="12" cy="13" r="8"></circle><path d="M12 9v4l2.5 2.5M9 2h6"></path></svg>
      <span className="lbl">WITHDRAWALS OPEN IN</span>
      <span className="mono" role="timer" style={{ fontWeight: "800", fontSize: "40px", lineHeight: "46px" }}>{clock(left)}</span>
      <span className="muted" style={{ fontSize: "12px", lineHeight: "17px" }}>You changed your wallet {sameDay ? "today" : "yesterday"} at {timeOf(changed)}. To keep your balance safe, a new wallet can withdraw 24 hours later.</span>
    </div>

    <div className="g" style={{ marginTop: "12px", borderRadius: "18px", padding: "4px 0" }}>
      <Line first label="New wallet">{walletName(view.wallet.appName)} <span className="mono muted">{shortAddress(view.wallet.address)}</span></Line>
      <Line label="Opens">{opensToday ? "Today" : "Tomorrow"} {timeOf(until)}</Line>
      <Line label="Available"><span className="mono">{view.withdraw.available} USDT</span></Line>
    </div>

    <p className="muted" style={{ margin: "12px 2px 0", fontSize: "12px", lineHeight: "17px" }}>You can keep depositing and battling meanwhile.</p>

    <button className="btnP" disabled style={{ marginTop: "14px", border: "0", opacity: "0.45", cursor: "not-allowed" }}>OPENS IN {clock(left)}</button>
    <a href={SUPPORT_URL} target="_blank" rel="noreferrer" className="btnS" style={{ marginTop: "10px" }}>I didn't change my wallet</a>
  </div>
</div>
    </>
  );
}
